import styled from 'styled-components'

export const FooterElement = styled.footer`
	padding: 0.25em 1em;
	textalign: center;
	font-size: 90%;
`
